import React from "react";
import cv from "../assets/cv/ABDOU_MOUSA.pdf";
export default function Resume() {

  return (
    <>
      <div
        className="container mx-auto py-10 max-width "
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <a
          href={ cv}
          download="ABDOU_MOUSA"
          className="ml-5 px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-md hover:from-blue-600"
        >
          Download CV
        </a>
        <iframe
          src={cv}
          title="Resume"
          className="w-full h-screen mt-5 border-2 border-gray-300 rounded-lg"
        ></iframe>

        <script></script>
      </div>
    </>
  );
}
